import * as React from "react";
import { forwardRef } from "react";
const SvgTumblr = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.176 1V4.91199H15.0879V8.03997H11.176V12.352C11.176 16.2799 13.928 15.8159 15.8639 14.536V17.9999C10.6 20.4799 6.47998 17.9519 6.47998 14.672V8.03997H4.13599V5.82398C4.93559 5.61822 5.69718 5.28603 6.39198 4.83999C6.89367 4.41111 7.30441 3.88613 7.59997 3.29599C7.94404 2.57327 8.16057 1.7965 8.23997 1H11.176Z", fill: "#333333" }));
const ForwardRef = forwardRef(SvgTumblr);
export { ForwardRef as ReactComponent };
